import { Anchor, Box, ButtonMantine, Modal, ModalProps, Stack, Text, Title } from 'ui';

type Props = ModalProps;

export const BrowserSupportModal = ({ opened, onClose }: Props) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={3}>This Browser Is Not Supported</Title>}
      size="lg"
    >
      <Stack>
        <Text type="body" c="gray">
          This browser doesn’t support Givebacks cashback.
          <br />
          Use Google Chrome to get cashback for you and your cause.
        </Text>
        <Box mt={32} mx={'auto'}>
          <Anchor href="https://www.google.com/chrome/" target="_blank">
            <ButtonMantine>Download Google Chrome</ButtonMantine>
          </Anchor>
        </Box>
      </Stack>
    </Modal>
  );
};
